import { Reveal } from "./Reveal";
import { MaskHeading } from "./Reveal";

export const PageHero = ({ eyebrow, lines, intro, testId = "page-hero", children }) => (
  <section className="relative pt-36 pb-16 md:pt-44 md:pb-24" data-testid={testId}>
    <div className="container-x grid gap-10 lg:grid-cols-12 lg:items-end">
      <div className="lg:col-span-8">
        <Reveal><p className="eyebrow">{eyebrow}</p></Reveal>
        <MaskHeading
          as="h1"
          onLoad
          lines={lines}
          className="font-display mt-6 text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl lg:text-7xl"
        />
      </div>
      {intro && (
        <Reveal delay={0.3} className="lg:col-span-4">
          <p className="text-base md:text-lg leading-relaxed text-[var(--ink-2)]">{intro}</p>
        </Reveal>
      )}
    </div>
    {children}
  </section>
);

export const SectionHead = ({ eyebrow, lines, intro, className = "" }) => (
  <div className={`grid gap-8 lg:grid-cols-12 lg:items-end ${className}`}>
    <div className="lg:col-span-7">
      <Reveal><p className="eyebrow">{eyebrow}</p></Reveal>
      <MaskHeading lines={lines} className="font-display mt-5 text-4xl leading-[1.04] tracking-tight sm:text-5xl lg:text-6xl" />
    </div>
    {intro && (
      <Reveal delay={0.15} className="lg:col-span-5">
        <p className="text-base md:text-lg leading-relaxed text-[var(--ink-2)]">{intro}</p>
      </Reveal>
    )}
  </div>
);
